import { Box, Typography, CircularProgress } from "@mui/material";

/**
 * Component that displays a thinking or processing message
 */
const ThinkingMessage = ({ content }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <CircularProgress size={16} />
      <Typography variant="body2">{content}</Typography>
    </Box>
  );
};

export default ThinkingMessage;
